import React from 'react';
import { IPlanOverviewDetail } from '@models/interfaces/user.interface';
import { getPlanContent } from '@components/subscription/overview/detail/PlanContent';
import { planName } from '@components/subscription/overview/helper/PlanDetailHelper';

export interface RecommendedPlanDetailProps {
  planDetail: IPlanOverviewDetail;
}

const RecommendedPlanDetail = ({ planDetail }: RecommendedPlanDetailProps) => {
  const items = getPlanContent(planDetail);

  return (
    <div>
      <div
        className={
          'px-4 lg:py-4 max-lg:py-2 rounded-t-2xl bg-primary-navyblue-bright text-neutral-chalk font-bold'
        }
      >
        Upgrade to {planName(planDetail)}
      </div>
      <div
        className={'max-lg:px-3 lg:px-5 py-4 bg-neutral-chalk rounded-b-2xl'}
      >
        {items.map((item, index) => (
          <div
            key={index}
            className={
              'flex max-lg:pb-4 lg:pb-6 last-of-type:!pb-0 text-neutral-marker'
            }
          >
            <div className={'w-[38px] mr-4'}>
              <img src={item.imageUrl} className={''} alt={''} />
            </div>
            <div>
              <div
                className={
                  'lg:text-md lg:leading-[22px] max-lg:text-sm max-lg:leading[19px]'
                }
              >
                {item.main}
              </div>
              <div
                className={
                  'lg:text-sm lg:leading-[19px] lg:font-bold max-lg:text-xs max-lg:leading[16px] max-lg:font-semibold text-primary-skyblue'
                }
              >
                {item.secondary}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecommendedPlanDetail;
